// src/graphql/queries.ts
import { gql } from '@apollo/client';

export const USERS = gql`
  query users {
    users {
      id
      username
      email
      company
      avatar
      role
      accessExpiry
      reason
      isBlocked
      phone 
      activityPattern
      grantedBy {
        id
        username
        avatar
        email
        phone
      }
      adminComment 
      loginHistory { date ip userAgent }
      subscriptionHistory { startDate endDate reason grantedByUsername grantedByEmail}
    }
  }
`;

export const ME = gql`
  query Me {
    me {
      id
      username
      email
      company
      avatar
      role
      isBlocked
      phone 
    }
  }
`;

export const GET_USER_BY_ID = gql`
  query GetUserById($id: ID!) {
    userById(id: $id) {
      id
      username
      email
      company
      avatar
      role
      isBlocked
      phone
      accessExpiry
      reason
      activityPattern
      grantedBy {   
        id
        username
        avatar
        email
        phone
      }
      adminComment 
      loginHistory { date ip userAgent }
      subscriptionHistory { startDate endDate reason grantedByUsername grantedByEmail}
    }
  }
`;

export const GET_NOTES = gql`
  query Notes {
    notes {
      id
      title
      content
      image
      previewImage
      tags
      createdAt
      updatedAt
      favoriteCount
      favoritedBy {
        id
        username
      }
      attachments {
        id
        size
        filename
        contentType
      }
    }
  }
`;

export const GET_NOTE_BY_ID = gql`
  query Note($id: ID!) {
    note(id: $id) {
      id
      title
      content
      image
      previewImage
      tags
      createdAt
      updatedAt
      favoriteCount
      favoritedBy {
        id
        username
      }
      attachments {
        id
        size
        filename
        contentType
      }
    }
  }
`;

export const CHECK_EMAIL_EXISTS = gql`
  query CheckEmailExists($email: String!) {
    checkEmailExists(email: $email)
  }
`;

export const GET_PAGE_CONTENT = gql`
  query GetPageContent($page: PageType!) {
    pageContent(page: $page) {
      id
      page
      contentType
      videoUrl
      title
      description
      noteId
      createdAt
      updatedAt
      __typename
    }
  }
`;